import { Link } from "react-router";
import { Card } from "../../components/Card";
import { PERSONAS } from "../../content/landing";
import styles from "./Personas.module.css";

const { kev, franco } = PERSONAS;

/**
 * Introduces Kev and Franco — which is also where the Sport/Fantasy vocabulary
 * enters, since the mode toggle in the app is the same distinction.
 *
 * The closing line is not decoration: guardrails §1.2 says the persona changes
 * the flavour, never the walls. Saying that on the marketing page is what stops
 * "Franco is the fun one" being read as "Franco is the loose one".
 */
export function Personas() {
  return (
    <>
      <p className={styles.intro}>{PERSONAS.intro}</p>

      <div className={styles.pair}>
        {[kev, franco].map((p) => (
          <Card key={p.name} className={styles.card}>
            <div className={styles.head}>
              <span className={styles.name}>{p.name}</span>
              <span className={styles.mode}>{p.mode}</span>
            </div>
            <p className={styles.body}>{p.body}</p>
          </Card>
        ))}
      </div>

      {/* The second "one rulebook" line was cut (Ned's cut list, 2026-10-05):
          PERSONAS.intro above already says it. The link stays. */}
      <p className={styles.rulebook}>
        <Link to="/team">{PERSONAS.more}</Link>
      </p>
    </>
  );
}
